import Bmdb from '@/js/bmdb'
import '@/css/style.scss'

export default Bmdb
